import { render, staticRenderFns } from "./salaryAdvance.vue?vue&type=template&id=44919d3c"
import script from "./salaryAdvance.vue?vue&type=script&lang=js"
export * from "./salaryAdvance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports